export const FatigueAssessmentAnswers = {
    hoursSleep24Hrs: {
        minTime: 2,
        maxTime: 5
    },
    hoursSleep48Hrs: {
        minTime: 8,
        maxTime: 12
    },
    hoursAwake: {
        minTime: 0,
        maxTime: 24
    }
}

export default FatigueAssessmentAnswers;